var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0798 59.0793H36.3408V56.4536H56.4541V36.3403H59.0798V59.0793Z",
    fill: "#4F0C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.739 59.0793H0V36.3403H2.62575V56.4536H22.739V59.0793Z",
    fill: "#4F0C84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.62575 22.739H0V0H22.739V2.62575H2.62575V22.739Z",
    fill: "#4F0C84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0798 22.739H56.4541V2.62575H36.3408V0H59.0798V22.739Z",
    fill: "#4F0C84"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7089 51.8588H7.2207V34.3706H24.7089V51.8588ZM9.84645 49.233H22.0831V36.9964H9.84645V49.233Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7089 24.7089H7.2207V7.2207H24.7089V24.7089ZM9.84645 22.0831H22.0831V9.84645H9.84645V22.0831Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8583 24.7089H34.3701V7.2207H51.8583V24.7089ZM36.9959 22.0831H49.2325V9.84645H36.9959V22.0831Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0428 51.8586H34.9492V49.2328H49.4171V47.4604H52.0428V51.8586Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0428 34.4956H49.417V45.0839H52.0428V34.4956Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4538 28.2271H2.62598V30.8528H56.4538V28.2271Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8523 2.62598H28.2266V56.4538H30.8523V2.62598Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5904 13.3389H13.3389V18.5904H18.5904V13.3389Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7408 13.3389H40.4893V18.5904H45.7408V13.3389Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5904 40.4893H13.3389V45.7408H18.5904V40.4893Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1345 34.4956H43.5088V40.6989H46.1345V34.4956Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1345 43.561H43.5088V49.8891H46.1345V43.561Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8834 46.6069H34.9492V43.9811H38.2577V40.2788H40.8834V46.6069Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8834 34.3711H34.9492V36.9968H40.8834V34.3711Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.2c7b06fae4fa53922c6320e798603125.svg";
export { ForwardRef as ReactComponent };